module.exports = __webpack_public_path__ + "img/save-selected.c1ae23fd.svg";